/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
<template>
  <div class="mb-5 pb-5">
    <div v-if="agronomoSelecionado.item != null">
      <b-badge v-if="parseInt(agronomoSelecionado.item.receita_art_disponivel) < 10" class="mt-2" variant="danger"><span
          class="h5 text-white">Saldo Receitas:
          {{ agronomoSelecionado.item.receita_art_disponivel }}</span></b-badge>
      <b-badge v-else class="mt-2" variant="primary"><span class="h5 text-white">Saldo Receitas Por ART:
          {{ agronomoSelecionado.item.receita_art_disponivel }}</span></b-badge>
    </div>
    <div class="row" v-show="itemReceita == null">
      <div class="col-md-12">
        <div class="borda"></div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group>
              <b-form-checkbox v-model="receita.complementar">
                Marcar como receita complementar
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-1" label="Responsável Técnico" label-for="filter">
              <template slot="description">
                <b v-if="agronomoSelecionado.item != null">CREA: {{ agronomoSelecionado.item.crea }}</b>
              </template>
              <v-select class="style-select" label="nome" :options="agronomos" :reduce="(item) => item" :dense="true"
                v-model="agronomoSelecionado.item" @input="$forceUpdate()"></v-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-1" label="Produtor" label-for="filter">
              <v-select class="style-select" label="nome" :options="produtores" :reduce="(item) => item" :dense="true"
                v-model="produtorSelecionado.item">
                <template #option="item">
                  <span>{{ item.nome }} - Endereço: {{ item.endereco }}</span>
                </template>
                <template #selected-option="item">
                  <span>{{ item.nome }} - Endereço: {{ item.endereco }}</span>
                </template>
              </v-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-1" label="Data de Emissão" label-for="input-2">
              <b-form-datepicker id="datepicker-final" v-model="dataEmissaoReceituario" placeholder="Data de emissão"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }" locale="pt-br">
                <template v-slot:button-content>
                  <b-icon icon="calendar" variant="primary"></b-icon>
                </template>
              </b-form-datepicker>
            </b-form-group>
          </div>
        </div>
        <div class="row" v-if="receita.complementar">
          <div class="col-md-3">
            <b-form-group label="Número da Receita Origem">
              <b-form-input v-model="receita.receitaOrigem" type="text" />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="ART Origem">
              <b-form-input v-model="receita.artOrigem" type="text" />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group label="NF" label-for="input-nf">
              <template slot="description">
                <b>Insira o número da Nota Fiscal</b>
              </template>
              <b-form-input type="text" v-model="receita.nf"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Série" label-for="input-nf">
              <template slot="description">
                <b>Insira a série da Nota Fiscal</b>
              </template>
              <b-form-input type="text" v-model="receita.serie_nf"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Valor R$" label-for="input-nf">
              <template slot="description">
                <b>Insira o valor R$ da Nota Fiscal</b>
              </template>
              <b-form-input type="text" v-model.lazy="receita.valor_nf" v-money="money"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Produto" label-for="filter">
              <v-select class="style-select" label="nomeProduto" :options="produtos" :reduce="(item) => item.idProduto"
                :dense="true" @input="handleConsultarCultura">
              </v-select>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Culturas" label-for="filter">
              <template slot="description">
                <b v-show="filter.id_produto == null || filter.id_produto.length === 0
                  ">Primeiro selecione o produto</b>
              </template>
              <v-select class="style-select" label="nomeComum" :options="culturas" :reduce="(item) => item.idCultura"
                :dense="true" @input="handleConsultarAlvos" :disabled="filter.id_produto != null && filter.id_produto > 0
                  ? false
                  : true
                  "></v-select>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Alvo" label-for="filter">
              <template slot="description">
                <b v-show="filter.id_cultura == null || filter.id_cultura.length === 0
                  ">Primeiro selecione a cultura</b>
              </template>
              <v-select class="style-select" label="nomeComum" :options="alvos" :reduce="(item) => item.idAlvo"
                :dense="true" @input="handleConsultarRelacao" :disabled="filter.id_produto > 0 && filter.id_cultura > 0 ? false : true
                  "></v-select>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>

    <div class="borda"></div>

    <div v-show="itemReceita == null && itens.length > 0">
      <b-table striped hover responsive borderless bordered outlined small :items="itens" :fields="itensFields"
        :per-page="perPage" caption-top>
        <template v-slot:cell(nomeComumAlvo)="row">
          {{ row.item.nomeComumAlvo }} - {{ row.item.nomeCientificoAlvo }}
        </template>
        <template v-slot:cell(actions)="row">
          <div class="btn-group mb-2">
            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="uil uil-ellipsis-v"></i>
              </template>
              <!-- <b-dropdown-item @click="editReceita(row.item)"
                >Editar</b-dropdown-item
              > -->
              <b-dropdown-item @click="modalDeleteItemReceita(row.item.idReceitaItem)">Excluir</b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
      <div class="row">
        <div class="col-sm-1 col-1">
          <button class="btn btn-primary" @click="handleEmitirReceita()">
            <span>Emitir</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="itemReceita == null"> </div>
    <div v-else>
      <div class="shadow p-3 mb-5 bg-white rounded">
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Produto:</b>
                  {{ this.itemReceita.produto.nome }} ({{
                    this.itemReceita.ingredientes.join(' ')
                  }})
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Cultura:</b>
                  {{ this.itemReceita.cultura.nomeComumCultura }} -
                  {{ this.itemReceita.cultura.nomeCientificoCultura }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Alvo:</b>
                  {{ this.itemReceita.praga.nomeComumPraga }} -
                  {{ this.itemReceita.praga.nomeCientificoPraga }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Responsável Técnico:</b>
                  {{ this.agronomoSelecionado.item.nome }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>
                  <b>Produtor:</b>
                  {{ this.produtorSelecionado.item.nome }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col-md-10">
                <b v-if="itemReceita.msgArea ===
                  'É necessário informar área manualmente.'
                ">É necessário informar área de aplicação manualmente.</b>
                <b v-else-if="itemReceita.msgArea === 'Não é necessário informar área.'
                ">Não é necessário informar área de aplicação.</b>
                <b v-else>O cálculo da área de aplicação é feito automaticamente quando
                  informado a quantidade do Produto.</b>
              </div>
              <div v-show="this.$store.state.auth.currentUser.user === 'agro_borges'" class="col-md-2"><b-link
                  @click="$bvModal.show('modal-doses')"><b>Ver doses</b></b-link></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group id="input-equipamento-aplicacao" label="Equipamento de aplicação" label-for="filter">

              <v-select class="style-select" label="nome" :options="equipamentos" :reduce="(item) => item" :dense="true"
                v-model="equipamentoSelecionado" @input="$forceUpdate()"></v-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group label="Nº aplicação" label-for="input-numero-aplicacao">
              <template slot="description"><b>Número de aplicação de
                  {{ this.itemReceita.numeroAplicacoesMin }} até
                  {{ this.itemReceita.numeroAplicacoesMax }}</b></template>
              <b-form-input v-model="$v.itemReceita.nAplicacoes.$model" :state="validateState('nAplicacoes')"
                type="text"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">O Número de aplicação é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Dose" label-for="input-numero-aplicacao">
              <template slot="description">
                <b>Dose de {{ this.itemReceita.doseMin }} até
                  {{ this.itemReceita.doseMax }}
                  {{ this.itemReceita.desc_unidade }}</b>
              </template>
              <b-form-input type="text" v-model="$v.itemReceita.dose.$model"
                :state="validateState('dose')"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">A dose é obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Volume de calda" label-for="input-calda">
              <template slot="description"><b>Volume de Calda de
                  {{ this.itemReceita.volumeCaldaMin }} até
                  {{ this.itemReceita.volumeCalda }}</b></template>
              <b-form-input type="text" v-model="$v.itemReceita.volumeCalda.$model"
                :state="validateState('volumeCalda')"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">O volume de calda é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Qtde." label-for="input-qtde">
              <b-form-input type="text" v-model="$v.itemReceita.qtdeAdquirir.$model"
                :state="validateState('qtdeAdquirir')" @blur="handleCalcularArea"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">A quantidade adquirida é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Unidade" label-for="select-unidade">
              <b-form-select id="select-unidade" :options="unidadesMedida" v-model="$v.itemReceita.unidade.$model"
                :state="validateState('unidade')">
                <template #first>
                  <b-form-select-option :value="null" disabled>Selecione…</b-form-select-option>
                </template>
              </b-form-select>
              <b-form-invalid-feedback>
                A unidade é obrigatória.
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Área tratada" label-for="input-qtde">
              <b-form-input type="text" v-model="$v.itemReceita.areaAplicacao.$model"
                :state="validateState('areaAplicacao')"></b-form-input>
              <b-form-invalid-feedback id="input-2-live-feedback">A área de aplicação é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
        <div class="row"> </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Modo de aplicação" label-for="input-2">
              <b-form-textarea class="form-control" id="input-2" rows="5" max-rows="6" type="text"
                placeholder="Modo de aplicação" v-model="$v.itemReceita.descModoAplicacao.$model"
                :state="validateState('descModoAplicacao')"></b-form-textarea>
              <b-form-invalid-feedback id="input-2-live-feedback">O modo de aplicação é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Recomendações de uso" label-for="input-2">
              <b-form-textarea class="form-control" id="input-2" rows="5" max-rows="6" type="text"
                placeholder="Recomendações de uso" v-model="$v.itemReceita.descRecomendacoes.$model"
                :state="validateState('descRecomendacoes')"></b-form-textarea>
              <b-form-invalid-feedback id="input-2-live-feedback">A recomentação é
                obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Recomendações adicionais (opcional)" label-for="input-2">
              <textarea class="form-control" id="input-2" rows="5" v-model="itemReceita.obs" type="text"
                placeholder="Recomendações adicionais (opcional)" required></textarea>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-2">
            <button class="btn btn-danger mr-2" @click="itemReceita = null">
              Cancelar
            </button>
            <button class="btn btn-primary" @click="criarReceita()">
              Adicionar
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="bv-modal-relacao" :title="titleModalRelacao" title-class="font-18" size="lg" scrollable
      :hide-footer="true">
      <div class="shadow p-3 mb-3 bg-white rounded" v-for="relacao in relacoes" :key="relacao.id">
        <div class="row">
          <div class="col-md-6">
            <label>
              <b>Produto:</b>
              {{ relacao.nome }} ({{ relacao.ingredientes.join(' ') }})
            </label>
          </div>
          <div class="col-6">
            <label>
              <b>Classe Toxicológica:</b>
              {{ relacao.classeToxicologica }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>
              <b>Cultura:</b>
              {{ relacao.nomeComumCultura }} -
              {{ relacao.nomeCientificoCultura }}
            </label>
          </div>
          <div class="col-md-4">
            <label>
              <b>Estágio:</b>
              {{ relacao.epocaCultura }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label>
              <b>Diagnóstico:</b>
              {{ relacao.nomeComumPraga }} - {{ relacao.nomeCientificoPraga }}
            </label>
          </div>
          <div class="col-6">
            <label>
              <b>Estágio:</b>
              {{ relacao.epocaPraga }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label>
              <b>Local de aplicação:</b>
              {{ relacao.localAplicacao }}
            </label>
          </div>
          <div class="col-6">
            <label>
              <b>Tipo de Aplicacao:</b>
              {{ relacao.tipoAplicacao }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <b-form-fieldset :feedback="feedback" label="Dosagens" :label-size="1">
                  <div class="row">
                    <div class="col-12">
                      <label>
                        <b>Mín:</b>
                        {{ relacao.doseMin }} {{ relacao.unidadeAplicacao }}
                      </label>
                    </div>
                    <div class="col-12">
                      <label>
                        <b>Máx:</b>
                        {{ relacao.doseMax }} {{ relacao.unidadeAplicacao }}
                      </label>
                    </div>
                  </div>
                </b-form-fieldset>
              </div>
              <div class="col-6">
                <b-form-fieldset :feedback="feedback" label="Aplicações" :label-size="1">
                  <div class="row">
                    <div class="col-12">
                      <label>
                        <b>Mínima:</b>
                        {{ relacao.numeroAplicacoesMin }}
                      </label>
                    </div>
                    <div class="col-12">
                      <label>
                        <b>Máxima:</b>
                        {{ relacao.numeroAplicacoesMax }}
                      </label>
                    </div>
                  </div>
                </b-form-fieldset>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label>
              <b>Volume de calda:</b>
              {{ relacao.volumeCalda }} {{ relacao.unidadeCultura }}
            </label>
          </div>
          <div class="col-4">
            <label>
              <b>Intervalo de segurança:</b>
              {{ relacao.intervaloSeguranca }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>
              <b>Modo/Época de aplicação:</b>
              {{ relacao.descModoAplicacao }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>
              <b>EPI:</b>
              {{ relacao.descEpi }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>
              <b>Precaução de uso:</b>
              {{ relacao.descPrecaucaoUso }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button class="btn btn-primary btn-block" @click="selecionarRelacao(relacao)">
              <span>Selecionar</span>
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="modalDelItem" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir o item da receita?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modalDelItem = false">Não</b-button>
        <b-button variant="danger" @click="handleDeleteItemReceita">Sim</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-doses" title="Doses para 20 L">
      <p class="my-4">
        ☑️ Magafol: 50 ml <br>
        ☑️ Sumyzin: 20 ml geral, para amendoim, 7 ml, fazer a pulverização em dias sem previsão de chuva<br>
        ☑️ Tenaz: 70 ml para 20 L. Para banana 1 ml (por planta na axila da terceira folha para o combate a
        Sigatoka)<br>
        ☑️ Tordon ultra-s: 100 ml, para plantas de mais fácil controle, para plantas de mais difícil controle, 150
        ml.<br>
        ☑️ Adesil: 10 ml (último a ser colocado na calda)<br>
        ☑️ Roundup original mais: 150 ml<br>
        ☑️ Nativo: 12 ml, pode ser utilizado como Tenaz para banana<br>
        ☑️ Padron: 300 ml<br>
        ☑️ Connect: 20 ml<br>
        ☑️ Galil: 10 ml<br>
        ☑️ Artys: 200 ml, para plantas de mais fácil controle, para plantas de mais difícil controle, 300 ml.<br>
        ☑️ Decis: 10 ml<br>
        ☑️ Zartan: Interessante de se utilizar com plantas de folhas pequenas como carquejas e vassourinhas. Diluir 1
        pacote em 1 L de água e utilizar 200 ml da mistura por bomba, tomar cuidado com culturas perenes como citrus,
        cacau e banana, pode causar fitotoxidez, se for utilizado com Roundup<br>
        ☑️ Brexil: 40 g<br>
        ☑️ Roundup ultra em pó: 100 g</p>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import formProdutor from '@/src/components/form-produtor'
import relReceita from '@src/components/rel-receita.vue'
import { mask } from 'vue-the-mask'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

import receitaService from '@/src/services/receita'
import produtorRural from '@src/services/produtor-rural'
import agronomoService from '@/src/services/agronomo'

import moment from 'moment'
import ItemReceita from '../services/request/item-receita'
import estoqueService from '@/src/services/api-receituario/estoque'
moment.locale('pt-br')
import { validationMixin } from 'vuelidate'
import { required, minLength, requiredIf } from 'vuelidate/lib/validators'
const greaterThanZero = (value) => value > 0
var currencyFormatter = require('currency-formatter')
import { VMoney } from 'v-money'
const momentTimeZone = require('moment-timezone');

/**
 * Produtor rural Component
 */
export default {
  mixins: [validationMixin],
  directives: { mask, money: VMoney },
  components: {
    Layout,
    Loading,
    formProdutor,
    DatePicker,
    relReceita,
  },
  props: {
    receita: {},
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      receita: this.$props.receita,
      idItemReceita: null,
      receitas: [],
      alvos: [],
      produtos: [],
      culturas: [],
      produtores: [],
      agronomos: [],
      relacoes: [],
      itens: [],
      produtorSelecionado: {},
      agronomoSelecionado: {},
      itemReceita: null,
      relacaoSelecionada: null,
      mostraForm: true,
      relatorioReceita: {},
      idReceita: null,
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      rows: 0,
      itensReceita: [ItemReceita],
      filter: {
        id_pragas: '',
        id_cultura: '',
        id_produto: '',
      },
      itensFields: [
        {
          key: 'nomeProduto',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'nomeComumCultura',
          label: 'Cultura',
          class: 'size-col-20',
        },
        {
          key: 'nomeComumAlvo',
          label: 'Diagnóstico',
          class: 'size-col-50',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      modalDelItem: false,
      titleModalRelacao: '',
      dataEmissaoReceituario: new Date(),
      equipamentoSelecionado: {},
      unidadesMedida: [
        { value: 'kg', text: 'kg' },
        { value: 'g', text: 'g' },
        { value: 'L', text: 'L' },
        { value: 'mL', text: 'mL' },
        { value: 'Fr', text: 'Frasco' },
        { value: 'Gl', text: 'Galão' },
      ],
      equipamentos:
        [
          {
            "id_tipo_aplicacao": 1,
            "nome": "Plantio direto",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 2,
            "nome": "Plantio convencional",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 3,
            "nome": "Sequeiro",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 4,
            "nome": "Irrigado",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 5,
            "nome": "Rasteiro",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 6,
            "nome": "Tutorado",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 7,
            "nome": "Cana-planta",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 8,
            "nome": "Cana-soca",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 9,
            "nome": "Aplicação sequencial",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 10,
            "nome": "Primeira aplicação",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 11,
            "nome": "Segunda aplicação",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 12,
            "nome": "Aplicação sequencial - 4 aplicações",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 13,
            "nome": "Aplicação localizada",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 14,
            "nome": "Aplicação dirigida (equipamento costal)",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 15,
            "nome": "sachet de 34 g\/5,66 m³",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 16,
            "nome": "Pastilhas de 3g \/ m³",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 17,
            "nome": "Comprimidos de 0,6g \/ m³ ",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 18,
            "nome": "Pulverização",
            "data_cadastro": "2016-12-01",
            "data_atualizacao": "2016-12-01"
          },
          {
            "id_tipo_aplicacao": 19,
            "nome": "Plantio direto",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 20,
            "nome": "Plantio convencional",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 21,
            "nome": "Sequeiro",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 22,
            "nome": "Irrigado",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 23,
            "nome": "Rasteiro",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 24,
            "nome": "Tutorado",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 25,
            "nome": "Cana-planta",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 26,
            "nome": "Cana-soca",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 27,
            "nome": "Aplicação sequencial",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 28,
            "nome": "Primeira aplicação",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 29,
            "nome": "Segunda aplicação",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 30,
            "nome": "Aplicação sequencial - 4 aplicações",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 31,
            "nome": "Aplicação localizada",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 32,
            "nome": "Aplicação dirigida (equipamento costal)",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 33,
            "nome": "sachet de 34 g\/5,66 m³",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 34,
            "nome": "Pastilhas de 3g \/ m³",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 35,
            "nome": "Comprimidos de 0,6g \/ m³ ",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2016-12-02"
          },
          {
            "id_tipo_aplicacao": 36,
            "nome": "Pulverização",
            "data_cadastro": "2016-12-02",
            "data_atualizacao": "2020-10-13"
          },
          {
            "id_tipo_aplicacao": 37,
            "nome": "Tratamento de Sementes",
            "data_cadastro": "2017-03-16",
            "data_atualizacao": "2017-03-16"
          },
          {
            "id_tipo_aplicacao": 38,
            "nome": "Aplicação em Área Total",
            "data_cadastro": "2018-12-06",
            "data_atualizacao": "2018-12-06"
          },
          {
            "id_tipo_aplicacao": 39,
            "nome": "Manutenção (pastagens)",
            "data_cadastro": "2018-12-06",
            "data_atualizacao": "2018-12-06"
          },
          {
            "id_tipo_aplicacao": 40,
            "nome": "Reforma (pastagens)",
            "data_cadastro": "2018-12-06",
            "data_atualizacao": "2018-12-06"
          },
          {
            "id_tipo_aplicacao": 41,
            "nome": "Aplicação Aérea",
            "data_cadastro": "2019-04-16",
            "data_atualizacao": "2019-04-16"
          },
          {
            "id_tipo_aplicacao": 42,
            "nome": "Imersão",
            "data_cadastro": "2019-05-07",
            "data_atualizacao": "2019-05-07"
          },
          {
            "id_tipo_aplicacao": 43,
            "nome": "Aplicação única",
            "data_cadastro": "2019-10-29",
            "data_atualizacao": "2019-10-29"
          },
          {
            "id_tipo_aplicacao": 44,
            "nome": "Esguicho (drench)",
            "data_cadastro": "2020-05-10",
            "data_atualizacao": "2020-05-10"
          },
          {
            "id_tipo_aplicacao": 45,
            "nome": "Aplicação Solos Arenosos",
            "data_cadastro": "2020-07-17",
            "data_atualizacao": "2020-07-17"
          },
          {
            "id_tipo_aplicacao": 46,
            "nome": "Aplicação Solos Médios",
            "data_cadastro": "2020-07-17",
            "data_atualizacao": "2020-07-17"
          },
          {
            "id_tipo_aplicacao": 47,
            "nome": "Aplicação Solos Argilosos",
            "data_cadastro": "2020-07-17",
            "data_atualizacao": "2020-07-17"
          },
          {
            "id_tipo_aplicacao": 48,
            "nome": "Rega",
            "data_cadastro": "2020-09-02",
            "data_atualizacao": "2020-09-02"
          },
          {
            "id_tipo_aplicacao": 49,
            "nome": "Dessecação",
            "data_cadastro": "2021-03-27",
            "data_atualizacao": "2021-03-27"
          },
          {
            "id_tipo_aplicacao": 50,
            "nome": "Pulverizador costal ou de barra",
            "data_cadastro": "2022-07-06",
            "data_atualizacao": "2022-07-06"
          },
          {
            "id_tipo_aplicacao": 51,
            "nome": "Atomizador costal motorizado"
          },
          {
            "id_tipo_aplicacao": 52,
            "nome": "Atomizador canhão modelo AF 427 bananeiro"
          },
          {
            "id_tipo_aplicacao": 53,
            "nome": "Pulverizadores manuais"
          },
          {
            "id_tipo_aplicacao": 54,
            "nome": "Pulverização costal",
            "data_atualizacao": "2022-07-06"
          },
          {
            "id_tipo_aplicacao": 55,
            "nome": "Pulverizador estacionário com mangueira"
          },
          {
            "id_tipo_aplicacao": 56,
            "nome": "Pulverizador tratorizado"
          },
          {
            "id_tipo_aplicacao": 57,
            "nome": "Pulverizador turboatomizadores"
          },
          {
            "id_tipo_aplicacao": 58,
            "nome": "Pulverização de barra horizontal"
          },
          {
            "id_tipo_aplicacao": 59,
            "nome": "Pulverização de barra vertical"
          },
          {
            "id_tipo_aplicacao": 60,
            "nome": "Pulverização tratorizada com barra"
          },
          {
            "id_tipo_aplicacao": 61,
            "nome": "Imersão"
          },
          {
            "id_tipo_aplicacao": 62,
            "nome": "ISCA"
          },
          {
            "id_tipo_aplicacao": 63,
            "nome": "Armadilha"
          },
          {
            "id_tipo_aplicacao": 64,
            "nome": "Geração de gás"
          },
          {
            "id_tipo_aplicacao": 65,
            "nome": "Aplicação ARP (Drones)"
          },
          {
            "id_tipo_aplicacao": 66,
            "nome": "Pulverizador Tratorizada de Tocos"
          },
          {
            "id_tipo_aplicacao": 67,
            "nome": "Tambores rotativos"
          },
          {
            "id_tipo_aplicacao": 68,
            "nome": "Pulverizadores costais"
          },
          {
            "id_tipo_aplicacao": 69,
            "nome": "Pulverizadores de barra acoplados a tratores"
          },
          {
            "id_tipo_aplicacao": 70,
            "nome": "Pulverizadores de mangueira"
          },
          {
            "id_tipo_aplicacao": 71,
            "nome": "Atomizadores (turbo-atomizadores)"
          },
          {
            "id_tipo_aplicacao": 72,
            "nome": "Pulverizadores acoplados ao trator"
          },
          {
            "id_tipo_aplicacao": 73,
            "nome": "Turbo pulverizador e gotas médias a médias\/grossas"
          },
          {
            "id_tipo_aplicacao": 74,
            "nome": "Pulverizadores costais (manual ou motorizado)"
          },
          {
            "id_tipo_aplicacao": 75,
            "nome": "Pulverizador manual ou tratorizado de barra"
          },
          {
            "id_tipo_aplicacao": 76,
            "nome": "Aéreo",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 77,
            "nome": "Barra Costal",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 78,
            "nome": "Pistolas de jato regulável",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 79,
            "nome": "Terrestre",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 80,
            "nome": "Costal Turbo Atomizador",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 81,
            "nome": "Avião",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 82,
            "nome": "Gotejo no solo",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 83,
            "nome": "Esguicho no solo",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 84,
            "nome": "Gotejamento",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 85,
            "nome": "Pulverizadores específicos",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 86,
            "nome": "Imersão de mudas",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 87,
            "nome": "Avião Ipanema",
            "data_cadastro": "2024-09-14",
            "data_atualizacao": "2024-09-14"
          },
          {
            "id_tipo_aplicacao": 88,
            "nome": "Equipamento de rosca sem fim",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 89,
            "nome": "Aplicação terrestre",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 90,
            "nome": "Equipamento costal manual",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 91,
            "nome": "Auto-propelido",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 92,
            "nome": "Atomizador motorizado costal ou tratorizado",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 93,
            "nome": "Pistola dosadora de haste longa",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 94,
            "nome": "Equipamento costal ou acoplado a tratores",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 95,
            "nome": "Sistema convencional com barra",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 96,
            "nome": "Jato dirigido \/ Esguicho (Drench)",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 97,
            "nome": "Não determinado",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 98,
            "nome": "Aeronaves agrícolas",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 99,
            "nome": "Tubo atomizador acoplado ao trator",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 100,
            "nome": "Aplicação baixo volume (BV)",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 101,
            "nome": "Pulverizações a volumes normais",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 102,
            "nome": "Costal e tratorizado",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 103,
            "nome": "Betoneiras",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 104,
            "nome": "Equipamentos com fluxo contínuo",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 105,
            "nome": "Terrestre tratorizado",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 106,
            "nome": "Terrestre tratorizado convencional",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 107,
            "nome": "Equipamento mecanizado (Roçaplic)",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 108,
            "nome": "Costal estacionário",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 109,
            "nome": "Turbo atomizadores tratorizados",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 110,
            "nome": "Pistolas de pulverização",
            "data_cadastro": "2024-09-15",
            "data_atualizacao": "2024-09-15"
          },
          {
            "id_tipo_aplicacao": 111,
            "nome": "Equipamento Bentley (Eliminação de soqueira)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 112,
            "nome": "Costal (Capina\/Catação química)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 113,
            "nome": "Aeronaves agrícolas (como maturador)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 114,
            "nome": "Terrestres em jato-dirigido",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 115,
            "nome": "Regador",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 116,
            "nome": "Pulverizador autopropelido ou tratorizado de barra (jato dirigido)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 117,
            "nome": "Pulverizador costal pressurizado",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 118,
            "nome": "Drones (ARP)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 119,
            "nome": "Aéreo (como maturador)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 120,
            "nome": "Sistema de irrigação - Pivô central",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 121,
            "nome": "Atomizadores ou pulverizadores tracionados",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 122,
            "nome": "Batelada",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 123,
            "nome": "Bicos centrífugos (atomizadores rotativos)",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 124,
            "nome": "Montados ou tracionados por trator",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 125,
            "nome": "Equipamento acoplado a tratores",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 126,
            "nome": "Máquinas específicas para tratamento de sementes",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 127,
            "nome": "Máquinas específicas com fluxo contínuo de sementes",
            "data_cadastro": "2024-09-16",
            "data_atualizacao": "2024-09-16"
          },
          {
            "id_tipo_aplicacao": 174,
            "nome": "Pulverizador manual ou tratorizado",
            "data_cadastro": null,
            "data_atualizacao": null
          },
          {
            "id_tipo_aplicacao": 141,
            "nome": "Granuladeiras",
            "data_cadastro": null,
            "data_atualizacao": null
          },
          {
            "id_tipo_aplicacao": 176,
            "nome": "Jato dirigido",
            "data_cadastro": null,
            "data_atualizacao": null
          }
        ]
    }
  },
  validations: {
    itemReceita: {
      nAplicacoes: {
        required,
        minLength: minLength(1),
      },
      dose: {
        required,
        minLength: minLength(1),
      },
      qtdeAdquirir: {
        required,
        maxValue: greaterThanZero,
      },
      unidade: {
        required
      },
      areaAplicacao: {
        required: requiredIf(function () {
          return this.itemReceita.calculaArea
        }),
      },
      volumeCalda: {
        required,
      },
      descRecomendacoes: {
        required,
        minLength: minLength(1),
      },
      descModoAplicacao: {
        required,
        minLength: minLength(1),
      },
    },
  },
  computed: {},
  watch: {},
  async mounted() {
    this.handleConsultarProdutores()
    this.handleConsultarAgronomo()
    this.handleConsultarProduto()
    await this.consultarItemReceita(this.receita.id)

    this.agronomoSelecionado.item = this.receita.agronomo
    this.produtorSelecionado.item = this.receita.produtor
  },
  methods: {
    updateSelect() {
      this.$forceUpdate()
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.itemReceita[name]
      return $dirty ? !$error : null
    },
    resetForm() {
      this.filter = {
        numero_receita: '',
      }

      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    handleConsultarProdutores() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      produtorRural
        .listar(token)
        .then((resposta) => {
          this.produtores = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    handleConsultarAgronomo() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      agronomoService
        .listar(token)
        .then((resposta) => {
          this.agronomos = resposta.data.data
          this.agronomoSelecionado.item = this.agronomos[0]
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    handleConsultarProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService
        .consultarProduto(token)
        .then((resposta) => {
          this.isLoading = false
          this.produtos = resposta.data.produto
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    handleConsultarCultura(produto) {
      if (produto == null) {
        this.filter.id_produto = null
        this.filter.id_cultura = null
        return
      }

      this.filter.id_produto = produto
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService
        .consultarCulturaPorProduto(token, produto)
        .then((resposta) => {
          this.isLoading = false
          this.culturas = resposta.data.cultura
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = false
        })
    },
    handleConsultarAlvos(cultura) {
      this.filter.id_cultura = cultura
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService
        .consultarAlvoPorProdutoCultura(
          token,
          this.filter.id_cultura,
          this.filter.id_produto
        )
        .then((resposta) => {
          this.isLoading = false
          this.alvos = resposta.data.alvo
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = false
        })
    },
    handleConsultarRelacao(alvo) {
      if (this.receita.complementar) {
        if (!this.receita.receitaOrigem || !this.receita.artOrigem) {
          this.$bvToast.toast('Receita marcada como complementar. Preencha obrigatoriamente o número da receita de origem e a ART de origem.', {
            title: 'Validação',
            variant: 'danger',
            solid: true,
          });
          return;
        }
      }
      this.filter.id_pragas = alvo
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService
        .consultarRelacao(
          token,
          this.filter.id_produto,
          this.filter.id_cultura,
          this.filter.id_pragas,
          this.produtorSelecionado.item.id_produtor_rural
        )
        .then((resposta) => {
          this.isLoading = false
          this.relacoes = resposta.data
          this.$bvModal.show('bv-modal-relacao')
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = false
          const msg = error.response.data.aviso.mensagem
          this.$bvToast.toast(msg, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },
    async abrirReceita() {
      if (this.receita == null || this.receita.id == null) {
        const receitaSent = {}

        receitaSent.produtorRural = {
          idProdutorRural: this.produtorSelecionado.item.id_produtor_rural,
        }
        receitaSent.agronomo = {
          idAgronomo: this.agronomoSelecionado.item.id_agronomo,
        }
        receitaSent.nf = this.receita.nf
        receitaSent.serieNf = this.receita.serie_nf
        var valor = currencyFormatter.unformat(this.receita.valor_nf, {
          locale: 'pt-BR',
          code: 'BRL',
        })
        receitaSent.valorNf = valor

        receitaSent.receitaOrigem = this.receita.receitaOrigem
        receitaSent.artOrigem = this.receita.artOrigem
        receitaSent.complementar = this.receita.complementar

        const token = this.$store.state.auth.currentUser.token
        const response = await receitaService
          .abrirReceita(token, receitaSent)
          .catch((error) => {
            this.isLoading = false
            const msg = error.response.data.aviso.mensagem
            this.$bvToast.toast(msg, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          })
        return response.data.sucesso.idReceita
      }
      return this.receita.id
    },
    async adicionarItemReceita(id) {
      if (id != null) {
        this.itemReceita.descEquipamentoAplicacao = this.equipamentoSelecionado.nome
        const token = this.$store.state.auth.currentUser.token
        this.itemReceita.receita.idReceita = id
        const response = await receitaService
          .addItemReceita(token, this.itemReceita)
          .catch((error) => {
            const msg = error.response.data.aviso.mensagem
            this.$bvToast.toast(msg, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.itensReceita.push(this.itemReceita)
          })
        if (response != undefined) this.itemReceita = null

        return response
      }
    },
    async criarReceita() {
      this.$v.itemReceita.$touch()
      if (this.$v.itemReceita.$anyError) {
        return
      }
      this.isLoading = true

      const id = await this.abrirReceita()

      const responseItemReceita = await this.adicionarItemReceita(id)
      if (responseItemReceita == undefined) {
        this.isLoading = false
        return
      }

      await this.consultarItemReceita(id)
      this.receita.id = id
      this.isLoading = false
    },

    selecionarRelacao(relacao) {
      this.$bvModal.hide('bv-modal-relacao')
      this.itemReceita = new ItemReceita()

      this.itemReceita.receita.idReceita = this.receita.id
      this.itemReceita.produtor = this.produtorSelecionado.item.nome
      this.itemReceita.agronomo = this.agronomoSelecionado.item.nome
      this.itemReceita.cultura.idCultura = relacao.idCultura
      this.itemReceita.cultura.nomeComumCultura = relacao.nomeComumCultura
      this.itemReceita.cultura.nomeCientificoCultura =
        relacao.nomeCientificoCultura
      this.itemReceita.praga.idPragas = relacao.idAlvo
      this.itemReceita.praga.nomeComumPraga = relacao.nomeComumPraga
      this.itemReceita.praga.nomeCientificoPraga = relacao.nomeCientificoPraga
      this.itemReceita.produto.idProduto = relacao.idProduto
      this.itemReceita.produto.nome = relacao.nome
      this.itemReceita.localAplicacao.idLocalAplicacao =
        relacao.idLocalAplicacao
      this.itemReceita.dose = relacao.doseMin
      this.itemReceita.doseMin = relacao.doseMin
      this.itemReceita.doseMax = relacao.doseMax
      this.itemReceita.volumeCalda = relacao.volumeCalda
      this.itemReceita.volumeCaldaMin = relacao.volumeCaldaMin
      this.itemReceita.nAplicacoes = relacao.numeroAplicacoesMin
      this.itemReceita.numeroAplicacoesMin = relacao.numeroAplicacoesMin
      this.itemReceita.numeroAplicacoesMax = relacao.numeroAplicacoesMax
      this.itemReceita.descEquipamentoAplicacao = relacao.descEpi
      this.itemReceita.descRecomendacoes = relacao.descPrecaucaoUso
      this.itemReceita.descModoAplicacao = relacao.descModoAplicacao
      this.itemReceita.unidade = relacao.idUnidadeDose
      this.itemReceita.desc_unidade = relacao.unidadeAplicacao
      this.itemReceita.ingredientes = relacao.ingredientes
      this.itemReceita.calculaArea = relacao.calculaArea
      this.itemReceita.msgArea = relacao.msgArea
      this.itemReceita.idItemProduto = relacao.id


      const objetoEncontrado = this.equipamentos.find(objeto => objeto.nome === relacao.tipoAplicacao);
      this.equipamentoSelecionado = objetoEncontrado
    },

    async consultarItemReceita(id) {
      if (id != null) {
        const token = this.$store.state.auth.currentUser.token

        const response = await receitaService.consultarItemReceita(token, id)
        this.receita.receitaOrigem = response.data.receitaOrigem
        this.receita.artOrigem = response.data.artOrigem
        this.receita.complementar = response.data.complementar
        this.itens = response.data.itens
      }
    },

    modalDeleteItemReceita(id) {
      this.modalDelItem = true
      this.idItemReceita = id
    },

    handleDeleteItemReceita() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true

      receitaService
        .delItemReceita(token, this.idItemReceita)
        .then((resposta) => {
          this.consultarItemReceita(this.receita.id)
          this.modalDelItem = false
          this.isLoading = false
        })
        .catch((error) => {
          this.modalDelItem = false
          this.isLoading = false
        })
    },

    handleEmitirReceita() {
      momentTimeZone.tz.setDefault('America/Sao_Paulo');
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true

      const dataHoraBrasil = momentTimeZone(this.dataEmissaoReceituario).format('YYYY-MM-DD');
      const data = {
        idReceita: this.receita.id,
        dataEmissao: dataHoraBrasil,
      }

      receitaService
        .emitir(token, data)
        .then((resposta) => {
          this.isLoading = false
          this.$bvToast.toast('Receita emitda com sucesso', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.baixaEstoqueReceituario(token, this.receita.id)
          this.$root.$emit('back')
        })
        .catch((error) => {
          this.isLoading = false
          const msg = error.response.data.aviso.mensagem
          this.$bvToast.toast(msg, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },

    async baixaEstoqueReceituario(token, id) {
      var config = JSON.parse(window.localStorage.getItem('configuracao'))
      if (config.baixa_estoque_receituario) {
        await estoqueService.baixaReceituario(token, id)
      }
    },

    handleCalcularArea() {
      if (
        this.itemReceita.calculaArea &&
        this.itemReceita.msgArea !== 'É necessário informar área manualmente.'
      ) {
        const token = this.$store.state.auth.currentUser.token
        this.isLoading = true

        receitaService
          .calcularArea(
            token,
            this.itemReceita.unidade,
            this.itemReceita.qtdeAdquirir,
            this.itemReceita.nAplicacoes,
            this.itemReceita.dose,
            this.itemReceita.volumeCalda
          )
          .then((resposta) => {
            const limite = 1000000;
            var area = resposta.data.sucesso.area;
            let numeroFormatado = area > limite ? parseFloat((area / 1000).toFixed(3)) : parseFloat(area.toFixed(2));
            this.itemReceita.areaAplicacao = numeroFormatado == 0 ? 1 : numeroFormatado
            this.isLoading = false
          })
          .catch((error) => {
            this.modalDelItem = false
            this.isLoading = false
          })
      }
    },
  },
}
</script>

<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  b {
    color: #008e75;
  }

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-emitir {
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 15px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>